import { GroupChatInformationScreenNavigationProps } from "./types"
import React from "react"
import { ScrollView, View } from "~/ui/primitives"
import { useTheme } from '~/ui/styled'
import { useSafeAreaInsets } from "~/ui/safe-area"
// import { Screen } from "~screens/screen"
import GroupChatInformation from "./group-chat-information-screen"
import { useRouteChatId } from "~hooks/useActiveChat"
import { scrollViewFillStyle } from "~/ui/scroll-layout"

// const ROOT: ViewStyle = {
//   flex: 1,
// }

const GroupChatInformationScreen: React.FC<GroupChatInformationScreenNavigationProps> = (props) => {
  const theme = useTheme()
  const insets = useSafeAreaInsets()
  const chatKey = useRouteChatId() ?? "default"
  return (
    <View style={{ flex: 1, minHeight: 0, overflow: "hidden", backgroundColor: theme.colors.background }}>
      <ScrollView
        style={scrollViewFillStyle}
        contentContainerStyle={{ 
          paddingBottom: insets.bottom + 100
        }}
        showsVerticalScrollIndicator={false}
        keyboardShouldPersistTaps="handled"
      >
        <GroupChatInformation key={chatKey} {...props}/>
      </ScrollView>
    </View>
  )
}

export default GroupChatInformationScreen
